export default __webpack_public_path__ + "media/chat-dsc.05be460d.svg";